import type {KeyBinding} from '@codemirror/view'

import {insertLink} from '../commands/insert-link'
import {splitBlockquoteIfBlankLine} from '../commands/split-blockquote-if-blank'

export const markdownBehaviorsKeymap: KeyBinding[] = [
  {
    key: 'Enter',
    run: splitBlockquoteIfBlankLine,
  },
  {
    key: 'Mod-Shift-u',
    run: insertLink,
  },
]
